import { render } from "./XLogin.vue?vue&type=template&id=bc4493a6&scoped=true"
import script from "./XLogin.vue?vue&type=script&lang=js"
export * from "./XLogin.vue?vue&type=script&lang=js"

import "./XLogin.vue?vue&type=style&index=0&id=bc4493a6&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4493a6"]])

export default __exports__